import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
`;

export const ContentContainer = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 1;
  border: 0;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;

export const SelectionContainer = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  border: 0.12rem ${props => props.isSelected ? '#F47C34' : '#282828'} solid;
  background-color: ${props => props.isSelected ? '#F47C34' : 'transparent'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.p`
  padding: 0;
  margin: 0;
  font-family: Montserrat;
  margin: 0 0.5rem 0 0.5rem;
  color: #282828;
`;

export const HelpButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;
  color: #888;
  padding: 0.2rem;

  &:hover {
    cursor: pointer;
  }
`;

export const HelpText = styled.p`
  background-color: #EEE;
  padding: 0.3rem 0.5rem;
  position: absolute;
  min-width: 30rem;
  font-family: Montserrat;
  color: #282828;
  top: 120%;
  z-index: 10;
`;